'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCurrentSession = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
exports.default = registerInactivityLogout;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');
var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
var _reactDom = require('react-dom');
var _reactDom2 = _interopRequireDefault(_reactDom);
var _isNumber = require('lodash/isNumber');
var _isNumber2 = _interopRequireDefault(_isNumber);
var _padStart = require('lodash/padStart');
var _padStart2 = _interopRequireDefault(_padStart);
var _javascriptStateMachine = require('javascript-state-machine');
var _javascriptStateMachine2 = _interopRequireDefault(_javascriptStateMachine);
var _pageVisibilityShim = require('page-visibility-shim');
var _reactDocumentTitle = require('react-document-title');
var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
var _bind = require('classnames/bind');
var _bind2 = _interopRequireDefault(_bind);
var _optixSessionRefreshUi = require('@energysavvy/optix-session-refresh-ui');
var _optixSessionRefreshUi2 = _interopRequireDefault(_optixSessionRefreshUi);
var _LoggedOutMessage = require('./components/LoggedOutMessage');
var _LoggedOutMessage2 = _interopRequireDefault(_LoggedOutMessage);
var _WarningStrap = require('./components/WarningStrap');
var _WarningStrap2 = _interopRequireDefault(_WarningStrap);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  'wrapper': 'optix-inactivity-logout-ui__index__wrapper___UXTJH',
  'visible': 'optix-inactivity-logout-ui__index__visible___2idPA',
  'hidden': 'optix-inactivity-logout-ui__index__hidden___3t7W-',
  'logoutWarning-enter': 'optix-inactivity-logout-ui__index__logoutWarning-enter___2NJVS',
  'logoutWarning-enterActive': 'optix-inactivity-logout-ui__index__logoutWarning-enterActive___1Qbzn',
  'logoutWarning-leave': 'optix-inactivity-logout-ui__index__logoutWarning-leave___2ikXJ',
  'logoutWarning-leaveActive': 'optix-inactivity-logout-ui__index__logoutWarning-leaveActive___1yWbl',
  'loggedOutMessage-enter': 'optix-inactivity-logout-ui__index__loggedOutMessage-enter___1KUe8',
  'loggedOutMessage-enterActive': 'optix-inactivity-logout-ui__index__loggedOutMessage-enterActive___O5MQH',
  'loggedOutMessage-leave': 'optix-inactivity-logout-ui__index__loggedOutMessage-leave___2V71h',
  'loggedOutMessage-leaveActive': 'optix-inactivity-logout-ui__index__loggedOutMessage-leaveActive___1bEas'
};
var STATES = {
  unauthenticated: '__unauthenticated__',
  authenticated: '__authenticated__',
  expired: '__expired__'
};
var WARNING_CUTOFF_MILLISECONDS = 60 * 5 * 1000;
var cx = _bind2.default.bind(styles);
function getTimeFromMs(ms) {
  var datetime = new Date(ms);
  return datetime.getMinutes() + ':' + (0, _padStart2.default)(datetime.getSeconds(), 2, '0');
}
function pageVisible() {
  return !Boolean(document[_pageVisibilityShim.hidden]);
}
function shouldUseNativeLoginPage(sessionData) {
  var userId = sessionData.user_id;
  return userId.substring(0, 5) !== 'saml:';
}
function parseExpirationString(expiration) {
  return new Date(expiration).getTime();
}
function getTransitionClassnames(prefix) {
  return {
    enter: styles[prefix + '-enter'],
    enterActive: styles[prefix + '-enterActive'],
    leave: styles[prefix + '-leave'],
    leaveActive: styles[prefix + '-leaveActive']
  };
}
var InactivityLogout = function (_React$Component) {
  _inherits(InactivityLogout, _React$Component);
  function InactivityLogout(props) {
    _classCallCheck(this, InactivityLogout);
    var _this = _possibleConstructorReturn(this, (InactivityLogout.__proto__ || Object.getPrototypeOf(InactivityLogout)).call(this, props));
    _this.onAuthenticated = _this.onAuthenticated.bind(_this);
    _this.onTick = _this.onTick.bind(_this);
    _this.onUnauthenticated = _this.onUnauthenticated.bind(_this);
    _this.authenticationStateMachine = _javascriptStateMachine2.default.create({
      initial: STATES.unauthenticated,
      events: [{
        name: 'unauthenticated',
        from: STATES.unauthenticated,
        to: STATES.unauthenticated
      }, {
        name: 'unauthenticated',
        from: STATES.authenticated,
        to: STATES.expired
      }, {
        name: 'unauthenticated',
        from: STATES.expired,
        to: STATES.expired
      }, {
        name: 'authenticated',
        from: STATES.unauthenticated,
        to: STATES.authenticated
      }, {
        name: 'authenticated',
        from: STATES.authenticated,
        to: STATES.authenticated
      }, {
        name: 'authenticated',
        from: STATES.expired,
        to: STATES.authenticated
      }]
    });
    return _this;
  }
  _createClass(InactivityLogout, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      (0, _optixSessionRefreshUi2.default)().addListener(_optixSessionRefreshUi.AUTHENTICATED, this.onAuthenticated);
      (0, _optixSessionRefreshUi2.default)().addListener(_optixSessionRefreshUi.UNAUTHENTICATED, this.onUnauthenticated);
      this.setState({
        msUntilLogout: null,
        expirationEpoch: null,
        authenticationState: this.authenticationStateMachine.current
      });
      (0, _optixSessionRefreshUi.getCurrentSession)();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _optixSessionRefreshUi2.default)().removeListener(_optixSessionRefreshUi.AUTHENTICATED, this.onAuthenticated);
      (0, _optixSessionRefreshUi2.default)().removeListener(_optixSessionRefreshUi.UNAUTHENTICATED, this.onUnauthenticated);
    }
  }, {
    key: 'onAuthenticated',
    value: function onAuthenticated(expiration, sessionData) {
      this.setState({
        sessionData: sessionData
      });
      var now = Date.now();
      var expirationEpoch = parseExpirationString(expiration);
      clearInterval(this.state.interval);
      this.authenticationStateMachine.authenticated();
      this.setState({
        expirationEpoch: expirationEpoch,
        interval: setInterval(this.onTick, 1000),
        msUntilLogout: expirationEpoch - now,
        authenticationState: this.authenticationStateMachine.current
      });
    }
  }, {
    key: 'onUnauthenticated',
    value: function onUnauthenticated() {
      clearInterval(this.state.interval);
      this.authenticationStateMachine.unauthenticated();
      this.setState({
        interval: null,
        msUntilLogout: 0,
        authenticationState: this.authenticationStateMachine.current
      });
    }
  }, {
    key: 'onTick',
    value: function onTick() {
      var now = Date.now();
      var msUntilLogout = this.state.expirationEpoch - now;
      if (msUntilLogout < 0) {
        this.onUnauthenticated();
      } else {
        this.setState({
          msUntilLogout: msUntilLogout
        });
      }
    }
  }, {
    key: 'getDocumentTitleWithCountdown',
    value: function getDocumentTitleWithCountdown() {
      var ms = this.state.msUntilLogout;
      var currentTitle = document.title;
      var countdownSuffix = ' until logged out - ';
      var countdownPattern = new RegExp('\\d{1,2}:\\d{2}' + countdownSuffix);
      var countdownIsActive = (0, _isNumber2.default)(ms) && ms < WARNING_CUTOFF_MILLISECONDS && ms !== 0;

      // Clear existing countdown, if any
      var newTitle = currentTitle.replace(countdownPattern, '');
      if (countdownIsActive) {
        // Prepend new countdown
        newTitle = '' + getTimeFromMs(ms) + countdownSuffix + newTitle;
      }
      return newTitle;
    }
  }, {
    key: 'getInactivityDisplay',
    value: function getInactivityDisplay() {
      if ((0, _isNumber2.default)(this.state.msUntilLogout) && this.state.authenticationState !== STATES.unauthenticated) {
        var showWarningStrap = pageVisible() && this.state.msUntilLogout < WARNING_CUTOFF_MILLISECONDS;
        if (this.state.msUntilLogout === 0) {
          return _react2.default.createElement(_LoggedOutMessage2.default, {
            key: 'inactivityLoggedOut',
            useNativeLoginPage: shouldUseNativeLoginPage(this.state.sessionData)
          });
        } else if (showWarningStrap) {
          return _react2.default.createElement(_WarningStrap2.default, {
            key: 'inactivityWarning',
            msUntilLogout: this.state.msUntilLogout
          });
        }
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var transitionName = this.state.msUntilLogout === 0 ? 'loggedOutMessage' : 'logoutWarning';
      var inactivityDisplay = this.getInactivityDisplay();
      var wrapperClass = cx('wrapper', {
        visible: inactivityDisplay,
        hidden: !inactivityDisplay
      });
      return _react2.default.createElement(_reactDocumentTitle2.default, {
        title: this.getDocumentTitleWithCountdown()
      }, _react2.default.createElement('div', {
        className: wrapperClass
      }, _react2.default.createElement(_CSSTransitionGroup2.default, {
        transitionName: getTransitionClassnames(transitionName),
        transitionEnterTimeout: 225,
        transitionLeaveTimeout: 225
      }, inactivityDisplay)));
    }
  }]);
  return InactivityLogout;
}(_react2.default.Component);
function registerInactivityLogout() {
  if (document.getElementById('inactivity-logout')) {
    // Already registered!
    return;
  }
  var inactivityElement = document.createElement('div');
  inactivityElement.setAttribute('id', 'inactivity-logout');
  document.body.appendChild(inactivityElement);
  _reactDom2.default.render(_react2.default.createElement(InactivityLogout), inactivityElement);
}
var deleteCurrentSession = exports.deleteCurrentSession = _optixSessionRefreshUi.deleteCurrentSession;